<template>
    <div>
        <dx-grid
            :url="url"
            :columns="columns"
            :title="title"
            :actions="actions"
            ref="grid"
            :selectionEnabled="true"
            :beforeSetupGrid="beforeSetupGrid"
        ></dx-grid>

        <v-dialog persistent v-model="drawWinnerDialog" max-width="400">
            <v-card class="pa-2">
                <v-card-title class="headline pl-0 py-2"
                    >Draw A Winner</v-card-title
                >
                <div style="overflow-y: auto; height: 300px">
                    <div
                        v-for="student in students"
                        style="border: 1px solid #eee;"
                        class="px-2 mb-2"
                    >
                        <div class="mb-2">
                            <div class="pt-2 font-weight-medium">
                                {{ student.nameH + " - " + student.name }}
                            </div>
                        </div>
                        <v-layout row>
                            <div class="pb-2">
                                Points: {{ student.pointsBalance }}
                            </div>
                        </v-layout>
                    </div>
                </div>
                <v-card-actions class="mx-0 mt-2">
                    <v-spacer></v-spacer>
                    <v-btn
                        color="default"
                        dark
                        @click="drawWinnerDialog = false"
                        >Close</v-btn
                    >
                    <v-btn
                        :loading="processing"
                        color="success"
                        @click="draw()"
                        :disabled="ifWinner()"
                        >draw</v-btn
                    ><v-spacer></v-spacer>
                </v-card-actions>

                <v-layout column justify-center align-center>
                    <div v-if="winner" class="title">Winner: {{ winner }}</div>
                    <v-btn
                        v-if="winner"
                        small
                        class="mt-0"
                        @click="removeWinner"
                        color="success"
                        >Remove & Retry</v-btn
                    >
                </v-layout>
            </v-card>
        </v-dialog>
    </div>
</template>

<script>
import moment from "moment";
import { formatCurrency, groupBy } from "../utils/helpers.js";

export default {
    data: () => ({
        title: "Chol Hamoed Program Students",
        actions: [],
        drawWinnerDialog: false,
        processing: false,
        students: [],
        selected: [],
        winner: "",
        url: "",
        regID: "",

        columns: [
            {
                label: "Yiddish Name",
                field: "nameH",
                visible: true,
                filterValues: [],
                filterValue: null,
                selectedFilterOperation: null,
            },
            {
                label: "Name",
                field: "name",
                visible: true,
                filterValues: [],
                filterValue: null,
                selectedFilterOperation: null,
            },
            {
                label: "Student ID",
                field: "studentID",
                visible: true,
                filterValues: [],
                filterValue: null,
                selectedFilterOperation: null,
            },
            {
                label: "Points Balance",
                field: "pointsBalance",
                type: "number",
                visible: true,
                filterValues: [],
                filterValue: null,
                selectedFilterOperation: null,
            },
            {
                label: "Branch",
                field: "branch",
                visible: true,
                filterValues: [],
                filterValue: null,
                selectedFilterOperation: null,
            },
            {
                label: "Class",
                field: "class",
                visible: true,
                filterValues: [],
                filterValue: null,
                selectedFilterOperation: null,
            },
            {
                label: "Section",
                field: "section",
                visible: true,
                filterValues: [],
                filterValue: null,
                selectedFilterOperation: null,
            },
            {
                label: "Pin",
                field: "pin",
                visible: true,
                filterValues: [],
                filterValue: null,
                selectedFilterOperation: null,
            },
            {
                label: "First Name Hebrew",
                field: "firstNameH",
                format: "",
                visible: true,
                filterType: "",
                filterValues: [],
                filterValue: null,
                selectedFilterOperation: null,
            },
            {
                label: "Last Name Hebrew",
                field: "lastNameH",
                format: "",
                visible: true,
                filterType: "",
                filterValues: [],
                filterValue: null,
                selectedFilterOperation: null,
            },
            {
                label: "First Name",
                field: "engName",
                format: "",
                visible: true,
                filterType: "",
                filterValues: [],
                filterValue: null,
                selectedFilterOperation: null,
            },
            {
                label: "Last Name",
                field: "lastName",
                format: "",
                visible: true,
                filterType: "",
                filterValues: [],
                filterValue: null,
                selectedFilterOperation: null,
            },
        ],
    }),
    created() {},
    methods: {
        async beforeSetupGrid() {
            this.userBranch = this.$store.state.authentication.branch;

            this.actions.push({
                text: "Draw a Winner",
                action: this.drawWinner,
                showOnSelection: true,
            });

            //await this.loadRegID();

            //const terms = await this.getTerms();

            // this.actions.push({
            //     text: "Select Term",
            //     type: "select",
            //     values: terms,
            //     value: this.regID,
            //     onSelected: this.onTermSelected,
            // });

            this.url = "cholHamoedProgramStudents";
        },
        async loadRegID() {
            this.regID = await this.$http.get("api/allStudents/getRegID");
        },
        async getTerms() {
            return await this.$http.get("api/allStudents/getRegTerms");
        },
        onTermSelected(value) {
            this.regID = value;

            this.url = "cholHamoedProgramStudents?regID=" + this.regID;

            this.$refs.grid.reloadDataSource(this.url);
        },
        drawWinner() {
            this.selected = this.$refs.grid.getSelectedRowsData();
            this.winner = "";

            this.students = this.selected;

            this.drawWinnerDialog = true;
        },
        ifWinner() {
            return !!this.winner;
        },
        draw() {
            let randomIndex = Math.floor(Math.random() * this.students.length);

            let winner = this.students[randomIndex];

            this.winner =
                winner.studentID +
                " - " +
                winner.nameH +
                " (" +
                winner.class +
                "|" +
                winner.section +
                ")";
        },
        removeWinner() {
            this.winner = "";
        },
    },
};
</script>
<style></style>
